import MediaAlbumCarousel from "./MediaAlbumCarousel";

export default MediaAlbumCarousel;
